/* tslint:disable */
/* eslint-disable */
/**
 * Rapurc API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LocalizedValue,
    LocalizedValueFromJSON,
    LocalizedValueFromJSONTyped,
    LocalizedValueToJSON,
    Metadata,
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './';

/**
 * Reusable material object
 * @export
 * @interface ReusableMaterial
 */
export interface ReusableMaterial {
    /**
     * 
     * @type {string}
     * @memberof ReusableMaterial
     */
    readonly id?: string;
    /**
     * Localized reusable material names
     * @type {Array<LocalizedValue>}
     * @memberof ReusableMaterial
     */
    localizedNames: Array<LocalizedValue>;
    /**
     * 
     * @type {Metadata}
     * @memberof ReusableMaterial
     */
    metadata: Metadata;
}

export function ReusableMaterialFromJSON(json: any): ReusableMaterial {
    return ReusableMaterialFromJSONTyped(json, false);
}

export function ReusableMaterialFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReusableMaterial {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'localizedNames': ((json['localizedNames'] as Array<any>).map(LocalizedValueFromJSON)),
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function ReusableMaterialToJSON(value?: ReusableMaterial | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'localizedNames': ((value.localizedNames as Array<any>).map(LocalizedValueToJSON)),
        'metadata': MetadataToJSON(value.metadata),
    };
}


